import { useEffect, useMemo } from 'react';

import { LabelType } from '../../../../store';
import { LabelPreviewType } from '../../Map/Labels/LabelEditing';
import { LabelStyleWithRotation } from './EditLabel';

interface UseEditLabelPreviewParams {
  marker: LabelType;
  newMarkerId: string;
  editedName: string;
  onPreviewChange?: (preview: LabelPreviewType | null) => void;
  changes: Partial<LabelStyleWithRotation>;
}

export function useEditLabelPreview({
  marker,
  newMarkerId,
  editedName,
  onPreviewChange,
  changes,
}: UseEditLabelPreviewParams) {

  const [ style, rotation ] = useMemo(() => {
    const { rotation, ...styleWithoutRotation } = changes;
    return [styleWithoutRotation, rotation];
  }, [changes]);

  const preview = useMemo(() => {
    return {
      labelId: marker.id,
      newLabelId: newMarkerId,
      name: editedName,
      style,
      rotation,
    };
  }, [style, editedName, marker.id, newMarkerId, rotation]);

  useEffect(() => {
    onPreviewChange?.(preview);
  }, [onPreviewChange, preview]);

  return preview;
}

export default useEditLabelPreview;
